import { create } from 'zustand';
import { combine } from 'zustand/middleware';
import { Like } from 'shared/@generated/models';

function likeKey(modelId: number, modelType: string) {
  return `${modelType}:${modelId}`;
}

const useLikesStore = create(
  combine(
    {
      likes: [] as Like[],
      statuses: {} as Record<string, boolean>,
    },
    (set, get) => ({
      setup: (likes: Like[]) => {
        set((state) => ({
          likes,
          statuses: {
            ...state.statuses,
            ...Object.fromEntries(
              likes.map((like) => [likeKey(like.model_id, like.model_type), true]),
            ),
          },
        }));
      },
      reset: () => {
        set({ likes: [], statuses: {} });
      },
      hasLiked: (modelId: number, modelType = 'App\\Models\\Listing') =>
        get().statuses[likeKey(modelId, modelType)] ??
        !!get().likes.find((like) => like.model_id === modelId && like.model_type === modelType),
      setStatuses: (statuses: { model_id: number; model_type: string; liked: boolean }[]) =>
        set((state) => ({
          statuses: {
            ...state.statuses,
            ...Object.fromEntries(
              statuses.map((status) => [likeKey(status.model_id, status.model_type), status.liked]),
            ),
          },
        })),
      add: (like: Like) =>
        set((state) => ({
          likes: [...state.likes, like],
          statuses: {
            ...state.statuses,
            [likeKey(like.model_id, like.model_type)]: true,
          },
        })),
      remove: (modelId: number, modelType = 'App\\Models\\Listing') =>
        set((state) => ({
          likes: [
            ...state.likes.filter(
              (like) => !(like.model_id === modelId && like.model_type === modelType),
            ),
          ],
          statuses: {
            ...state.statuses,
            [likeKey(modelId, modelType)]: false,
          },
        })),
    }),
  ),
);

export default useLikesStore;
